<template>
    <div class="nav-menu-wrapper flex-shrink-0">
        <isc-menu
            :default-active="active"
            mode="vertical"
            background-color="transparent"
            text-color="#333333"
            active-text-color="#047AFF"
        >
            <isc-menu-item v-for="nav in navs" :key="nav[0]" :index="nav[0]" @click="active = nav[0]">
                {{ nav[1] }}
            </isc-menu-item>
        </isc-menu>
    </div>
</template>

<script>
export default {
    name: 'TheNavMenu',

    model: {
        prop: 'value',
        event: 'update:value'
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        navs: {
            type: Array,
            // [value, label]
            default: () => []
        }
    },

    data() {
        return {
            // navs: this.nav
        };
    },

    computed: {
        active: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('update:value', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-menu-wrapper {
    user-select: none;

    ::v-deep {
        .isc-menu {
            padding: 0;
            border-right: 0;

            &-item {
                border-radius: 0;
                font-size: 14px;
                height: 52px;
                line-height: 52px;
                margin: 0;
                padding-left: 48px;

                &:hover {
                    background: #f2f2f2 !important;
                }

                &.is-active,
                &.is-active:hover {
                    background: linear-gradient(270deg, #047aff00 0, #047aff4d 100%) !important;
                }
            }
        }
    }
}
</style>
